import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ConventionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">All Believers International Convention</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Annual global apostolic summit gathering saints from every nation under one banner, 
            one message, and one purpose in Christ
          </p>
        </div>
      </section>

      {/* What is ABIC */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">A Global Apostolic Summit</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  All Believers International Convention (ABIC) is the annual flagship gathering of 
                  Peter Akinnubi Apostolic Mandate, bringing together believers from every nation 
                  for a powerful time of apostolic teaching, worship, fellowship, and Kingdom advancement.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  ABIC represents the culmination of the year's ministry activities across all nine 
                  strategic arms of PAAM. It serves as a spiritual family reunion where the global 
                  Ecclesia gathers to receive fresh vision, celebrate God's faithfulness, and prepare 
                  for greater Kingdom exploits in the coming year.
                </p>
                <blockquote className="text-lg italic text-[#b8144a] border-l-4 border-[#b8144a] pl-6 my-6">
                  "Behold, how good and how pleasant it is for brethren to dwell together in unity!" - Psalm 133:1
                </blockquote>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Large%20international%20Christian%20convention%20with%20thousands%20of%20diverse%20believers%20from%20different%20nations%20gathered%20in%20worship%2C%20massive%20conference%20hall%20filled%20with%20people%20raising%20hands%20in%20praise%2C%20global%20apostolic%20summit%20with%20flags%20from%20many%20countries%2C%20inspiring%20atmosphere%20of%20unity%20and%20spiritual%20celebration&width=600&height=500&seq=abic-convention-1&orientation=landscape"
                alt="All Believers International Convention"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Convention Highlights */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Convention Highlights</h2>
            <p className="text-xl text-gray-600">What makes ABIC a transformative experience</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Apostolic Teaching</h3>
              <p className="text-gray-700 text-center">
                Powerful sessions with Apostle Peter Akinnubi and other anointed ministers, 
                delivering fresh revelation and apostolic insight
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-music-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Global Worship</h3>
              <p className="text-gray-700 text-center">
                Unified worship experiences with believers from every nation, creating 
                a foretaste of heavenly worship around the throne
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">International Fellowship</h3>
              <p className="text-gray-700 text-center">
                Networking and relationship building with believers and leaders from 
                different cultures, nations, and ministry backgrounds
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Supernatural Ministry</h3>
              <p className="text-gray-700 text-center">
                Powerful ministry sessions with healing, deliverance, prophetic ministry, 
                and supernatural demonstrations of God's power
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-compass-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Vision Casting</h3>
              <p className="text-gray-700 text-center">
                Strategic sessions outlining the vision and direction for PAAM's 
                global expansion and Kingdom advancement initiatives
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Recognition & Commissioning</h3>
              <p className="text-gray-700 text-center">
                Celebration of ministry achievements and commissioning of new leaders 
                for expanded roles in the global mandate
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Convention Schedule */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Typical Convention Schedule</h2>
            <p className="text-xl text-gray-600">A transformative 4-day spiritual journey</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="text-center mb-4">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">1</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Day One</h3>
                <p className="text-sm text-gray-600">Opening & Welcome</p>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Registration & Welcome</li>
                <li>• Opening Ceremony</li>
                <li>• Apostolic Address</li>
                <li>• International Fellowship</li>
                <li>• Evening Worship</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="text-center mb-4">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">2</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Day Two</h3>
                <p className="text-sm text-gray-600">Teaching & Training</p>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Morning Devotion</li>
                <li>• Apostolic Teaching</li>
                <li>• Workshop Sessions</li>
                <li>• Ministry Training</li>
                <li>• Evening Ministry</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="text-center mb-4">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">3</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Day Three</h3>
                <p className="text-sm text-gray-600">Power & Ministry</p>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Prayer & Intercession</li>
                <li>• Healing Service</li>
                <li>• Prophetic Ministry</li>
                <li>• Deliverance Session</li>
                <li>• Miracle Service</li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="text-center mb-4">
                <div className="w-12 h-12 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-2">
                  <span className="text-white font-bold">4</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900">Day Four</h3>
                <p className="text-sm text-gray-600">Commissioning & Sending</p>
              </div>
              <ul className="space-y-2 text-sm text-gray-700">
                <li>• Vision Casting</li>
                <li>• Leadership Commissioning</li>
                <li>• Covenant Renewal</li>
                <li>• Closing Ceremony</li>
                <li>• Sending Forth</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Past Conventions */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Convention Impact</h2>
            <p className="text-xl text-gray-600">Testimonies from past ABIC gatherings</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#b8144a] mb-2">50+</h3>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Nations Represented</h4>
              <p className="text-gray-700">Believers from over 50 nations have participated in ABIC gatherings</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-follow-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#b8144a] mb-2">1000+</h3>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Leaders Commissioned</h4>
              <p className="text-gray-700">Over 1000 leaders have been commissioned for ministry through ABIC</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-church-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#b8144a] mb-2">200+</h3>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">Churches Planted</h4>
              <p className="text-gray-700">Over 200 churches have been planted as a result of ABIC vision</p>
            </div>
          </div>
        </div>
      </section>

      {/* Next Convention */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20conference%20venue%20with%20stage%20setup%20for%20international%20Christian%20convention%2C%20professional%20lighting%20and%20sound%20equipment%2C%20large%20screens%20displaying%20ABIC%20branding%2C%20empty%20auditorium%20ready%20for%20thousands%20of%20attendees%2C%20representing%20preparation%20for%20global%20apostolic%20gathering&width=600&height=500&seq=next-convention-1&orientation=landscape"
                alt="Next ABIC Convention"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">ABIC 2025</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  Join us for the next All Believers International Convention - a gathering that 
                  promises to be the most impactful yet, with believers from every continent 
                  coming together for apostolic teaching, supernatural ministry, and Kingdom advancement.
                </p>
                <div className="bg-[#b8144a] text-white p-6 rounded-lg mb-6">
                  <h3 className="text-xl font-bold mb-4">Convention Details</h3>
                  <ul className="space-y-2">
                    <li>• <strong>Theme:</strong> "From Mandate to Movement"</li>
                    <li>• <strong>Duration:</strong> 4 Days of Transformation</li>
                    <li>• <strong>Languages:</strong> Multiple language translations</li>
                    <li>• <strong>Accommodation:</strong> Arranged for international delegates</li>
                    <li>• <strong>Registration:</strong> Early bird discounts available</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Registration */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Register for ABIC 2025</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Don't miss this life-changing gathering of the global Ecclesia. Register now and be part 
            of the apostolic movement that is transforming nations through the doctrine of Christ.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              Register Now
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer">
              Download Brochure
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <i className="ri-calendar-line text-4xl mb-4"></i>
              <h4 className="text-xl font-bold mb-2">Save the Date</h4>
              <p className="text-white/90">Mark your calendar for this transformative gathering</p>
            </div>
            
            <div className="text-center">
              <i className="ri-plane-line text-4xl mb-4"></i>
              <h4 className="text-xl font-bold mb-2">Travel Arrangements</h4>
              <p className="text-white/90">We assist with travel and accommodation planning</p>
            </div>
            
            <div className="text-center">
              <i className="ri-group-line text-4xl mb-4"></i>
              <h4 className="text-xl font-bold mb-2">Group Discounts</h4>
              <p className="text-white/90">Special rates for church groups and delegations</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}